import React from "react"
import styled from "styled-components"

const StyledCard = styled.div`
  min-height: 2rem;
  text-align: left;
  margin-top: -3px;
  padding: 15px;
  padding-bottom: 10px;
  font-size: var(--font-small);
  line-height: var(--line-small);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  box-shadow: inset 0px 2px 2px 2px rgba(0,0,0,0.15), inset 0px -2px 0px 0px rgba(255,255,255,0.15);
`

const Description = styled.div`
  font-weight: bold;
  line-height: var(--line-regular);
`

const CustomText = styled.div`
  margin-top: 0.5rem;
  margin-bottom: 5px;
`

const RelatedTechHeader = styled.div`
  margin-top: 1rem;
  font-weight: bold;
  text-transform: uppercase;
  font-size: var(--font-sub);
  letter-spacing: -0.3px;
`

type RelatedTechProps = {
  techlist: JSX.Element
  isjob: boolean
}

const RelatedTech = ({techlist, isjob}: RelatedTechProps) => {
  const header = isjob ? "Related Skills" : "Related Technologies"
  return (
    <div>
      <RelatedTechHeader>{header}</RelatedTechHeader>
      {techlist}
    </div>
  )
}

type Props = {
  description?: string
  customtext?: string | JSX.Element
  relatedtech?: JSX.Element
  isjob?: boolean
}

const DropDown = ({description, customtext, relatedtech, isjob=false}: Props) => {
  return (
  <StyledCard>
    <Description>{description}</Description>
    {customtext && <CustomText>{customtext}</CustomText>}
    {relatedtech && <RelatedTech techlist={relatedtech} isjob={isjob}/>}
  </StyledCard>
  )
}

export default DropDown
